var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu"},[_c('dl',{class:{menu_ico_dl : _vm.menuID == 3}},_vm._l((_vm.menus),function(item,index){return _c('dd',{key:index,class:{ cur : item.id == _vm.curIDprop },on:{"click":function($event){return _vm.navTo(item,index)}}},[_vm._v("\n\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }